import { RouteChangesListener } from "./addEventListenerWithTelemetry";
import {
  setupClickEvents,
  setupButtonClickEvents,
  setupMouseEnterEvents,
  setupScrollEvents,
  setupSelectChangeEvents,
  setupRadioButtonChangeEvents,
  setupCheckboxChangeEvents,
  setupFocusInEvents,
  setupFocusOutEvents,
  setupFormControlChangeEvents,
  setupFormSubmitEvents,
} from "./interactiveUserEvents";



let userEvents = [
  "buttonClick",
  "linkClick",
  "scroll",
  "focusIn",
  "focusOut",
  "formControlChange",
  "formSubmit",
  "mouseEnter",
  "selectChange",
  "radioButtonChange",
  "checkboxChange",
  "RouteChange",
];

// If the user wants to include only specific events, they can pass an array of those events as an argument
export function initializeTracingLibrary(selectedEvents = []) {
  console.log("Tracer provider and exporter initialized");
  if (selectedEvents.length > 0) {
    userEvents = selectedEvents;
  }

  if (userEvents.includes("buttonClick")) {
    setupButtonClickEvents();
  }
  if (userEvents.includes("linkClick")) {
    setupClickEvents();
  }
 /* if (userEvents.includes("scroll")) {
    setupScrollEvents();
  }*/
  if (userEvents.includes("focusIn")) {
    setupFocusInEvents();
  }
  if (userEvents.includes("focusOut")) {
    setupFocusOutEvents();
  }
  if (userEvents.includes("formControlChange")) {
    setupFormControlChangeEvents();
  }
  if (userEvents.includes("formSubmit")) {
    setupFormSubmitEvents();
  }
  if (userEvents.includes("mouseEnter")) {
    setupMouseEnterEvents();
  }
  if (userEvents.includes("selectChange")) {
    setupSelectChangeEvents();
  }
  if (userEvents.includes("radioButtonChange")) {
    setupRadioButtonChangeEvents();
  }
  if (userEvents.includes("checkboxChange")) {
    setupCheckboxChangeEvents();
  }
  if (userEvents.includes("RouteChange")) {
    RouteChangesListener();
  }

}


